
// Table name
export const LEMBRETES_TABLE = 'Lembretes';
